 

function getter(json) {
   return function(key) {
      if (!json.hasOwnProperty(key)) {
         var errorStr = 'Property ' + key + ' does not exist!';
         throw errorStr;
      }
      return json[key];
   };
}

window.cart_constants = {
   Address: getter({
      LOCAL_COUNTRY_CODE: "US",
      NAME_COUNTRY_CODE: "country_code",

      USER_VERIFIED: "user_verified",
      VERIFIED: "verified"
   }),

   BaseURI: getter({
      SITEIMAGE_LOADING: 'https://d1ulmmr4d4i8j4.cloudfront.net/static/images/cart/loading-20100504.gif',
      SITEIMAGE_IPHONELIBKIT: "https://d1ulmmr4d4i8j4.cloudfront.net/static/images/LiberationWeek/2014/iphonelibkit.png"
   }),

   CartMessageLib: getter({
      GETMESSAGE_FAILURE: "An unknown error occurred."
   }),

   CartURI: getter({
      CART: "/cart/view",
      LOGIN: "/Login",
      NEW_PLACE_ORDER: "/cart/place-order",
      SITE_HOMEPAGE: "/",
      ORDER_HISTORY: "/User/Orders"
   }),

   GuideURI: getter({
      USER_REVIEWS_LINK: '/User/Reviews',
   }),

   RegistrationLib: getter({
      FULL_NAME_INDEX: "fullName",
      COMPANY_INDEX: "company",
      ADDRESS_LINE1_INDEX: "address1",
      ADDRESS_LINE2_INDEX: "address2",
      ADDRESS_CITY_INDEX: "city",
      ADDRESS_STATE_INDEX: "state",
      ADDRESS_COUNTRY_INDEX: "country",
      ADDRESS_ZIP_INDEX: "postal",

      EMAIL_INDEX: "email",

      GETFORMSELECTOR_COUNTRY_DROPDOWN_INDEX:
       '.js-cc-country-dropdown',

      CREDIT_CARD_NUMBER_INDEX:
       "js-cc-number",
      CREDIT_CARD_STRIPE_CARDID_INDEX:
       "js-cc-cardid",
      CREDIT_CARD_MONTH_EXP_INDEX:
       "js-cc-exp-month",
      CREDIT_CARD_YEAR_EXP_INDEX:
       "js-cc-exp-year",
      CREDIT_CARD_STRIPE_LABEL_INDEX:
       "js-cc-label",

      CREDIT_CARD_SECURITY_INDEX:
       "js-cc-security",

      FORM_NUMBER_INDEX:
       '.js-cc-number',
      FORM_SECURITY_INDEX:
       '.js-cc-security',
      FORM_MONTH_EXP_INDEX:
       '.js-cc-exp-month',
      FORM_YEAR_EXP_INDEX:
       '.js-cc-exp-year',
      FORM_FULL_NAME_INDEX:
       '.js-cc-name',
      FORM_ADDRESS_COUNTRY_INDEX:
       '.js-cc-country',
      FORM_ZIP_INDEX:
       '.js-cc-postal-code',
      FORM_STRIPE_CARDID_INDEX:
       '.js-cc-cardid',
      FORM_STRIPE_TOKEN_INDEX:
       '.js-token-stripe',
      FORM_CARD_FRAUD_INDEX:
       '.js-fraud-info'
   }),

   PaymentId: getter({
      NO_PAYMENT: '0',

      CREDIT_CARD: '1',
      PAYPAL: '2',
      MONEY_ORDER: '3',
      PURCHASE_ORDER: '4',
      GOOGLE_CHECKOUT: '5',
      EBAY: '6',
      STACKSOCIAL: '7',
      REPAIRSHOPR: '8',
      STRIPE: '9',
      PAID_PO: '10',

      APPLE_PAY: 'apple-pay'
   }),

   PlaceOrderDisplayLib: getter({
      FULL_NAME_INDEX: "fullName",
      COMPANY_INDEX: "company",
      LINE1_INDEX: "line1",
      LINE2_INDEX: "line2",
      CITY_INDEX: "city",
      STATE_INDEX: "state",
      STATE_DISPLAY_INDEX: "stateDisplay",
      COUNTRY_INDEX: "country",
      POSTAL_INDEX: "postal",

      METHOD_SHIPPINGID_INDEX: "shippingid",
      METHOD_NAME_INDEX: "name",
      METHOD_RATE_INDEX: "rate",
      METHOD_DATE_INDEX: "time"
   })

}
